<template>
  <div class="header">
    <div class="padding14-15 cen-between bg-white">
      <van-row>
        <div class="logo f-l-l">
          <img src="../assets/imgs/logo.png" alt="logo" />
        </div>
        <span
            class="padding5-8 ft12 downText m-l-045 ftwh400 f-l-l"
            @click="goDownApp"
            >下载APP</span
          >
        <!-- <van-button color="#F4F4F4" size="mini m-l-045 padding5-8 ft12" class="f-l-l downText" @click="goDownApp"
          >下载APP</van-button
        > -->
        <div class="ftwh400 row cen-start f-l-r">
          <span
            v-if="!isUser"
            class="padding5-8 login-btn ft12"
            @click="goLogin"
            >注册/登录</span
          >
          <span v-if="isUser" @click="quitClick" class="userBox ilbk">
            <img :src="headImg" alt="" />
          </span>
          <span v-if="isUser" class="triangle">
            <img src="../assets/imgs/triangle.png" alt="" />
          </span>
          <!-- <van-search v-model="value" class="searchWidth" @click="goSearch" placeholder="搜索" /> -->
        </div>
      </van-row>
    </div>
    <div
      v-if="isQuit"
      class="gray-8 ft12 absolute bg-white quitBox text-center"
    >
      <p @click="quitUser" class="row cen-center">
        <span class="icon">
          <img src="../assets/imgs/exit.png" alt="" />
        </span>
        退出账号
      </p>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import { CacheModule } from "@/utils/commonUtils.js";
import { store, mutations } from "@/observable/store";
export default {
  name: "headCom",
  data() {
    return {
      isQuit: false,
      QQLoginPng: require("@/assets/imgs/login/Qq.png"),
      QQLogin: {
        appid: "101941950",
        appKey: "858be1491b7bbd566d9c9c6e8f833eee",
      },
      value: "",
      //  isUser: false,
    };
  },
  created() {
    if (this.tokenPhone) {
      this.$store.commit("Login/editIsUser", true);
    }
    let qqOpenid = localStorage.getItem("qqOpenidType");
    let wxOpenid = localStorage.getItem("wxOpenidType");
    let headimgurl = localStorage.getItem("headimgurl");
    if (headimgurl != null)
      this.$store.commit("Login/editHeadimgurl", headimgurl);
    if (wxOpenid != null) this.$store.commit("Login/editWxBingType", true);
    if (qqOpenid != null) this.$store.commit("Login/editQqBingType", true);
  },
  computed: {
    tokenPhone() {
      return store.tokenPhone;
    },
    isUser() {
      return this.$store.state.Login.isUser;
    },

    headImg() {
      // let img = ''
      let imgSrc = this.$store.state.Login.personalInfo.headimgurl;
      let localSrc = require("@/assets/imgs/user.png");
      return imgSrc != "" ? imgSrc : localSrc;
    },
  },
  activated() {
    if (this.tokenPhone) {
      // this.isUser = true
      this.$store.commit("Login/editIsUser", true);
    }
    // if(CacheModule.get('setToken')){
    //   this.isUser = true
    // }
  },
  watch: {
    isUser: {
      //分享
      handler(newVal) {
        // this.isUser = newVal
        this.$store.commit("Login/editIsUser", newVal);
      },
      deep: true,
    },
  },
  methods: {
    goDownApp(){
      this.$router.push("downApp");
    },
    goSearch() {
      this.$router.push("classification");
    },
    // 绑定QQ接口
    QQBind() {
      QC.Login.showPopup({
        appId: "101941950",
        redirectURI: "https://mceshi.xzjy365.com/QQLogin", //登录成功后会自动跳往该地址
      });
      // window.location.href=`https://graph.qq.com/oauth2.0/authorize?response_type=code&client_id=${this.QQLogin.appid}&redirect_uri=http://mceshi.xzjy365.com/liveList&state=QQ&display=mobile`
    },

    goLearn() {
      this.$router.push({
        path: "/learning",
      });
    },
    quitClick() {
      this.isQuit = !this.isQuit;
    },
    order() {
      this.$router.push({
        path: "/order",
      });
    },
    quitUser() {
      CacheModule.remove("loginPhone");
      CacheModule.remove("setToken");
      CacheModule.remove("qqOpenidType");
      CacheModule.remove("wxOpenidType");
      CacheModule.remove("uid");
      CacheModule.remove("userInfo");
      sessionStorage.clear();
      // localStorage.clear()
      mutations.getToken(false);
      // this.isUser = false
      this.$store.commit("Login/editIsUser", false);
      this.isQuit = false;
    },
  },
};
</script>
<style lang="less" scoped>
.downText {
  color: #333333 !important;
  border: 1px solid #cccccc !important;
  height: 0.8rem;
  background: #F4F4F4;
  border-radius: 6px;
}
.searchWidth {
  width: 80px;
  padding: 0;
  border-radius: 50px;
  .van-search__content {
    border-radius: 20px;
  }
}
.icon {
  width: 0.75rem;
  height: 0.75rem;
  display: inline-block;
  margin-top: -1rem;
  margin-right: 0.25rem;
  img {
    width: 100%;
  }
}
.marginTop {
  margin-top: -0.8rem;
}
.userBox {
  width: 21/20rem;
  height: 21/20rem;
  img {
    width: 100%;
  }
}
.triangle {
  width: 8/20rem;
  height: 5/20rem;
  margin-left: 5/20rem;
  margin-top: -1.3rem;
  img {
    width: 100%;
  }
}
.quitBox {
  width: 90/20rem;
  // height: 2rem;
  line-height: 2rem;
  right: 0.75rem;
  top: 2.4rem;
  border: 1px solid rgba(238, 238, 238, 1);
  border-radius: 2px;
  z-index: 999;
}
.boederBto {
  border-bottom: 1px solid rgba(238, 238, 238, 1);
}
.header {
  box-shadow: 0px 3px 7px 0px rgba(0, 0, 0, 0.15);
}
.logo {
  width: 83/20rem;
  height: 21/20rem;
}
.learn {
  padding-right: 15/2/20rem;
}
.login-btn {
  background: linear-gradient(
    90deg,
    rgba(247, 173, 108, 1),
    rgba(240, 129, 66, 1)
  );
  box-shadow: 0px 0px 8px 1px rgba(241, 132, 69, 0.45);
  border-radius: 6px;
  color: #fff;
}
</style>
